import { Component, Input, OnInit, Output, EventEmitter } from "@angular/core";
import {
  ControlValueAccessor,
  FormControl,
  NG_VALUE_ACCESSOR,
  Validators,
} from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { TranslationModuleEnum } from "src/app/utils/translation-modules.enum";
import { differenceInCalendarDays } from "date-fns";

@Component({
  selector: "app-nz-date-picker",
  templateUrl: "./date-picker.component.html",
  styleUrls: ["./date-picker.component.scss"],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: DateComponent,
      multi: true,
    },
  ],
})
export class DateComponent implements ControlValueAccessor, OnInit {
  translationModulesEnum = TranslationModuleEnum;
  language: string = this.translateService.currentLang;
  defaultDateFormat: string =
    this.language == "en" ? "dd-MM-yyyy" : "yyyy-MM-dd";
  @Input() disabled: boolean = false;
  @Input() placeholder: string =
    this.translateService.instant("shared.selectDate");
  @Input() isSubmitted: boolean = false;
  @Input() ShowTime: boolean = false;
  @Input() control: FormControl | undefined;
  @Input() title: string;
  @Input() maxDate: any;
  @Input() minDate: any;
  @Input() ShowToday: boolean = true;
  @Input() showDayOnInput: boolean = false;
  @Input() labelTranslationKey: string;
  @Input() labelTranslationModuleEnum: number;
  @Input() placeholderTranslationKey: string = "shared.selectDate";
  @Input() placeholderTranslationModuleEnum: number =
    this.translationModulesEnum.shared;
  @Input() isRange = false;

  get isRequired() {
    return this.control?.hasValidator(Validators.required);
  }
  private onChange = (value: string) => {};
  private onTouched = () => {};
  @Input() value: any;
  disabledDate = (dateValue: Date) => {
    const maxDate =
      this.maxDate === "today" ? new Date() : new Date(this.maxDate);

    if (this.minDate == "today") {
      return (
        differenceInCalendarDays(dateValue, maxDate) > 0 ||
        differenceInCalendarDays(new Date(), dateValue) > 0
      );
    }
    if (this.minDate == "yesterday") {
      return (
        differenceInCalendarDays(dateValue, maxDate) > 0 ||
        differenceInCalendarDays(new Date(Date.now() - 86400000), dateValue) > 0
      );
    }

    return (
      differenceInCalendarDays(dateValue, maxDate) > 0 ||
      differenceInCalendarDays(new Date(this.minDate), dateValue) > 0
    );
  };
  disabledHours = (dateValue: Date) => {
    const hours = [];
    const currentDate = new Date();
    const currentHour = currentDate.getHours();

    if (dateValue?.toDateString() === currentDate.toDateString()) {
      for (let i = 0; i <= currentHour; i++) {
        hours.push(i);
      }
    }
    return {
      nzDisabledHours: () => hours,
      nzDisabledMinutes: () => [],
      nzDisabledSeconds: () => [],
    };
  };

  @Output() onChangeEvent: EventEmitter<any> = new EventEmitter();
  @Output() onInputChange: EventEmitter<any> = new EventEmitter();

  constructor(private translateService: TranslateService) {}

  ngOnInit(): void {
    // console.log(this.maxDate)
  }

  writeValue(obj: any): void {
    if (obj == "1970-01-01T00:00:00.000Z") {
      this.value = null;
      this.onChange(null);
      return;
    }
    this.value = obj;
    this.onChange(obj);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  change() {
    // console.log();
    this.onChange(this.value);
    this.onChangeEvent.emit(this.value);
    // console.log("from change ", this.value)
  }

  inputChange() {
    this.onChange(this.value);
    this.onInputChange.emit(this.value);
  }
}
